// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"42":"85785b56","793":"39b49c77","941":"3a121e00","944":"e893a094"}[chunkId] + ".chunk.css";
};